import {Hub} from 'yougile-model'
import {uploadCover} from '@client/upload-cover'
import {Tracking, TrackingEvent} from '@common/tracking'
import {Task} from '@extensions/task'

export const useTaskCover = (hub: Hub, type: 'board' | 'right-panel') => ({
  uploadCover: () => uploadCover(hub, type),
  removeCover: () => {
    if (type === 'board') {
      void Tracking.send(TrackingEvent.taskCoverRemoveCoverViaBoardTaskMenu)
    }
    if (type === 'right-panel') {
      void Tracking.send(
        TrackingEvent.taskCoverRemoveCoverViaRightPanelTaskMenu
      )
    }

    Task.removeTaskCover(hub)
  }
})
